import axios from "axios";
import toastr from 'toastr'; 
export const CREATE_REVIEWER = "CREATE_REVIEWER";
export const CREATE_REVIEWER_ERR = 'CREATE_REVIEWER_ERR';


export const createReviewer = (data) => {
    return dispatch => {
        axios
        .post(
            "https://us-central1-promising-saga-232017.cloudfunctions.net/superAdminApi/addNewReviewer",
            data
        )
        .then(function(res) {
            console.log("RESPONSE FROM SERVER REVIEWER CREATION:", res);
            
            if(res.data === "error has been ocured") {
                toastr.error("Error occured. Please try again later");
                dispatch({
                    type: CREATE_REVIEWER_ERR
                });
            }

            if(res.data === 'successfully registered') {
                toastr.success("Reviewer created successfully");
                dispatch({
                    type: CREATE_REVIEWER,
                    payload: data
                });
            }
          })
          .catch(function(error) {
              console.log("ERROR FROM SERVER REVIEWER CREATION:", error);
            toastr.error("Error occured. Please try again later");
            dispatch({
              type: CREATE_REVIEWER_ERR
            });
          });
      };
};  